import React from 'react';
import { AuthForm } from '../../components/auth/AuthForm';
import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { PageTitle } from '../../components/layout/PageTitle';
import { PageLayout } from '../../components/layout/PageLayout';
import { useTranslation } from '../../hooks/useTranslation';
import { SEO } from '../../components/seo/SEO';

export function Login() {
  const { t, getPathForLang } = useTranslation();

  const forgotPasswordLink = (
    <div className="text-right mt-2">
      <Link
        to={getPathForLang('/reset-password')}
        className="text-sm font-medium text-primary-600 hover:text-primary-500"
      >
        {t('auth.login.forgot_password')}
      </Link>
    </div>
  );

  return (
    <PageLayout
      disableAds={true}
      className="bg-gray-50"
    >
      <SEO
        title={t('auth.login.seo.title')}
        description={t('auth.login.seo.description')}
      />
      <div className="min-h-[calc(100vh-4rem)] flex flex-col justify-center py-6 sm:py-12 sm:px-6 lg:px-8">
        <div className="text-center sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            {t('auth.login.title')}
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            {t('auth.login.subtitle')}
          </p>
          <p className="mt-2 text-center text-sm text-gray-600">
            {t('auth.login.no_account')}{' '}
            <Link
              to={getPathForLang('/register')}
              className="font-medium text-primary-600 hover:text-primary-500"
            >
              {t('auth.login.create_account')}
            </Link>
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md px-4 sm:px-0">
          <div className="bg-white py-8 px-4 shadow-xl sm:rounded-lg sm:px-10">
            <AuthForm
              mode="login"
              additionalElement={forgotPasswordLink}
            />
          </div>
        </div>
      </div>
    </PageLayout>
  );
}